/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  bodyContent,
  footerContent,
  size = "md",
  isCentered = true,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered={isCentered}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay
        bg="blackAlpha.500"
        // backdropFilter="blur(10px) hue-rotate(90deg)"
      />
      <ModalContent>
        {title && (
          <ModalHeader bg="bgColor" color="white" fontSize="md">
            {title}
          </ModalHeader>
        )}
        <ModalCloseButton color={title ? "white" : "black"} />
        <ModalBody maxHeight="78vh" overflowY="auto">
          {bodyContent}
        </ModalBody>
        {footerContent && <ModalFooter p={2}>{footerContent}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
